import React, { useState, useEffect } from "react";
import { Rnd } from "react-rnd";
import Icon1 from "../../icons/Icon";
import PrimaryButton from "../../buttons/PrimaryButton";
import SecondaryButton from "../../buttons/SecondaryButton";

function TextEditModal({ isOpen, onClose, initialText, onSave }) {
  const [text, setText] = useState(initialText);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div className="flex flex-col gap-2 bg-white p-4 w-c300 rounded-lg ">
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="w-full h-32 p-2 border border-gray-300 rounded-lg text-h2"
          style={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            resize: "none",
          }}
          placeholder="Tapez ici..."
        />
        <div className="flex flex-row gap-2 justify-end">
          <SecondaryButton className={"w-fit"} onClick={onClose}>
            Annuler
          </SecondaryButton>{" "}
          <PrimaryButton
            className={"w-fit"}
            onClick={() => {
              onSave(text);
              onClose();
            }}
          >
            Enregistrer
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

function DraggableResizableField({
  field,
  onDrag,
  onResize,
  onDelete,
  onTextEdit,
  editorMode,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [text, setText] = useState(field.content || "");
  const [isDropped, setIsDropped] = useState(false); // Track if the field is dropped

  const handleTextSave = (newText) => {
    setText(newText);
    onTextEdit(newText); // Update the parent component
    setIsDropped(false); // Reset dropped state after saving
  };

  // Open the modal when the field is dropped
  useEffect(() => {
    if (editorMode === "edit") {
      setIsModalOpen(true);
    }
  }, [editorMode]);

  return (
    <>
      <Rnd
        className="z-10"
        position={{ x: field.left, y: field.top }}
        size={{ width: field.width, height: field.height }}
        bounds="parent"
        enableResizing={{
          top: false,
          right: true,
          bottom: true,
          left: false,
          bottomRight: true,
          bottomLeft: false, // Enable resizing from bottom-left corner
          topRight: false,
          topLeft: false,
        }}
        onResizeStop={(e, direction, ref) => {
          const newWidth = parseInt(ref.style.width, 10);
          const newHeight = parseInt(ref.style.height, 10);
          onResize(newWidth, newHeight);
          setIsDropped(true); // Mark as dropped after resizing
        }}
        onDragStop={(e, d) => {
          onDrag(d.x, d.y);
          setIsDropped(true); // Mark as dropped after dragging
        }}
      >
        <div
          className="w-full h-full items-center justify-center text-clip border-2 border-black border-dashed relative flex bg-blue-300 opacity-65 rounded-lg "
          style={{
            fontSize: !["Signature", "Tampon"].includes(field.type)
              ? `${Math.min(field.width, field.height) * 0.5}px`
              : "18px",
          }}
        >
          {text || field.name || field.type}
          <div
            onClick={onDelete}
            className="absolute bg-black rounded-full cursor-pointer p-1 z-20 hover:bg-red-500  -top-3 -right-3"
          >
            <Icon1 icon_name="delete" fill="white" size={15} />
          </div>
          <div className="absolute bg-black rounded-full cursor-pointer p-1 z-20 hover:bg-red-500  -bottom-3 -right-3">
            <Icon1 icon_name="resize" fill="white" size={15} />
          </div>
        </div>
      </Rnd>

      {/* Modal for Text Editing */}
      {editorMode === "edit" && (
        <TextEditModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setIsDropped(false); // Reset dropped state when modal is closed
          }}
          initialText={text}
          onSave={handleTextSave}
        />
      )}
    </>
  );
}

export default DraggableResizableField;
